import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 5" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-5",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "radice",
				transform: "translate(194.444444, 277.777778)",
				strokeWidth: 28,
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle",
					stroke: "#0056C1",
					x: 374.944318,
					y: 99.3398379,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("polyline", {
					id: "Path",
					stroke: "#424548",
					points: "-1.89478063e-12 304.349629 111.13044 472.287803 274.413329 1.89478063e-12 612.990073 1.89478063e-12"
				})]
			})]
		})
	})]
});
export default SvgRadice;
